import { type QueryClient } from '@tanstack/react-query'

/**
 * every onboarding mutation invalidates the setup query (for the hub
 * checklist) and its own resource query. centralizing this avoids
 * inline Promise.all blocks across every step provider.
 */
export function invalidateOnboarding(
  queryClient: QueryClient,
  resourceQueryKey: string
): Promise<void> {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ['setup'] }),
    queryClient.invalidateQueries({ queryKey: [resourceQueryKey] })
  ]).then(() => undefined)
}
